<template>
  <a-layout-sider :width="'auto'">
    <transition-group name="air__menuFlyout__animation" :duration="1">
      <template v-for="(item, index) in renderedFlyoutItems">
        <div
          :key="`a-${index}`"
          :style="{
            left: `${
              item.itemDimensions.left + item.itemDimensions.width - 10
            }px`,
            top: `${item.itemDimensions.top}px`,
          }"
          :class="{
            [$style.air__menuFlyout]: true,
            [$style.air__menuFlyoutLeft]: settings.menuLayoutType === 'left',
            [$style.air__menuFlyout__black]:
              settings.flyoutMenuColor === 'dark',
            [$style.air__menuFlyout__white]:
              settings.flyoutMenuColor === 'white',
            [$style.air__menuFlyout__gray]: settings.flyoutMenuColor === 'gray',
          }"
        >
          <ul
            :class="$style.air__menuLeft__list"
            @mouseenter="handleFlyoutContainerOver(item.key)"
            @mouseleave="handleFlyoutOut(item.key)"
          >
            <template v-for="(item, index) in item.items">
              <item
                :key="`b-${index}`"
                :item="item"
                :styles="$style"
                :activeItem="activeItem"
              />
            </template>
          </ul>
        </div>
      </template>
    </transition-group>
    <div
      :class="{
        [$style.air__menuLeft]: true,
        [$style.air__menuLeft__mobileToggled]: settings.isMobileMenuOpen,
        [$style.air__menuLeft__toggled]: settings.isMenuCollapsed,
        [$style.air__menuLeft__unfixed]: settings.isMenuUnfixed,
        [$style.air__menuLeft__shadow]: settings.isMenuShadow,
        [$style.air__menuLeft__flyout]: settings.menuType === 'flyout',
        [$style.air__menuLeft__compact]: settings.menuType === 'compact',
        [$style.air__menuLeft__blue]: settings.menuColor === 'blue',
        [$style.air__menuLeft__white]: settings.menuColor === 'white',
        [$style.air__menuLeft__gray]: settings.menuColor === 'gray',
        [$style.air__menuFlyout__black]:
          settings.flyoutMenuColor === 'dark' &&
          settings.menuType !== 'default',
        [$style.air__menuFlyout__white]:
          settings.flyoutMenuColor === 'white' &&
          settings.menuType !== 'default',
        [$style.air__menuFlyout__gray]:
          settings.flyoutMenuColor === 'gray' &&
          settings.menuType !== 'default',
      }"
    >
      <div :class="$style.air__menuLeft__outer">
        <a
          href="javascript: void(0);"
          :class="$style.air__menuLeft__mobileToggleButton"
          @click="toggleMobileMenu"
        >
          <span />
        </a>
        <a
          href="javascript: void(0);"
          :class="$style.air__menuLeft__toggleButton"
          @click="toggleMenu"
        >
          <span />
          <span />
        </a>
        <a
          href="/"
          :class="$style.air__menuLeft__logo"
          :title="nomeSaleChannel"
        >
          <!-- logo de acordo com canal de  venda -->
          <img
            :src="logo"
            :alt="nomeSaleChannel"
            style="max-width: 150px; max-height: 40px"
          />
        </a>
        <a href="javascript: void(0);" :class="$style.air__menuLeft__user">
          <div :class="$style.air__menuLeft__user__avatar">
            <air-user-menu />
          </div>
          <div :class="$style.air__menuLeft__user__name">{{ nome }}</div>
          <div :class="$style.air__menuLeft__user__role">{{ papeis }}</div>
        </a>

        <vuescroll>
          <div :class="$style.air__menuLeft__container">
            <ul :class="$style.air__menuLeft__list">
              <template v-for="(item, index) in menuData">
                <template v-if="verificaPermissao(item.roles) && verificarFeature(item.features)">
                  <item
                    v-if="!item.children && !item.category"
                    :key="`c-${index}`"
                    :item="item"
                    :styles="$style"
                    :activeItem="activeItem"
                  />
                  <sub-menu
                    v-if="item.children"
                    :key="`d-${index}`"
                    :item="item"
                    :styles="$style"
                    :activeItem="activeItem"
                    :activeSubmenu="activeSubmenu"
                    :handleSubmenuClick="handleSubmenuClick"
                    :handleFlyoutOver="handleFlyoutOver"
                    :handleFlyoutOut="handleFlyoutOut"
                    :handlePermission="verificaPermissao"
                    :handleFeature="verificarFeature"
                  />
                  <category
                    v-if="item.category"
                    :key="`e-${index}`"
                    :item="item"
                    :styles="$style"
                  />
                </template>
              </template>
            </ul>
          </div>
        </vuescroll>
        <div class="front-version">v-{{ getFrontEndVersion }}</div>
      </div>
    </div>
    <a
      href="javascript: void(0);"
      :class="$style.air__menuLeft__backdrop"
      @click="toggleMobileMenu"
    />
  </a-layout-sider>
</template>

<script>
import vuescroll from "vuescroll";
import vueCustomScrollbar from "vue-custom-scrollbar";
import _ from "lodash";
import { mapState, mapGetters } from "vuex";
import { getMenuData } from "@/menu";
import SubMenu from "./partials/submenu";
import Item from "./partials/item";
import Category from "./partials/category";
import AirUserMenu from "@/components/layout/TopBar/UserMenu";

const LOGO_BASE = "resources/images/logowhite.png";
const AVATAR_BASE = "resources/images/avatars/avatar.png";
const NOME_BASE = "Acquire";
export default {
  name: "menu-left",
  components: { vuescroll, SubMenu, Item, Category, AirUserMenu },
  computed: {
    ...mapState(["settings"]),
    ...mapGetters({
      getFrontEndVersion: "getFrontEndVersion",
      getConfig: "getConfig",
    }),
    logo() {
      try {
        return this.getConfig.logo || LOGO_BASE;
      } catch (e) {
        return LOGO_BASE;
      }
    },
    avatar() {
      try {
        return AVATAR_BASE;
      } catch (e) {
        return AVATAR_BASE;
      }
    },
    nomeSaleChannel() {
      try {
        return this.getConfig.name || NOME_BASE;
      } catch (e) {
        return NOME_BASE;
      }
    },
    flyoutActive() {
      return (
        (this.settings.menuType === "flyout" ||
          this.settings.menuType === "compact" ||
          this.settings.isMenuCollapsed) &&
        !this.settings.isMobileView
      );
    },
    nome() {
      try {
        return this.$store.getters.user.fullname;
      } catch (e) {
        return "";
      }
    },
    papeis() {
      try {
        return this.$store.getters.user.role.split(",").join("|");
      } catch (e) {
        return "";
      }
    },
    features() {
      try {
        return this.$store.getters.user.features;
      } catch (e) {
        return [];
      }
    },
    papeisRaw() {
      try {
        return this.$store.getters.user.role.split(",");
      } catch (e) {
        return [];
      }
    },
  },
  mounted() {
    this.setActiveItems();
  },
  data() {
    return {
      menuData: getMenuData,
      activeSubmenu: "",
      activeItem: "",
      settingsScrollBar: {
        suppressScrollY: false,
        suppressScrollX: false,
        wheelPropagation: false,
      },
      renderedFlyoutItems: {},
      flyoutTimers: {},
    };
  },
  watch: {
    $route() {
      this.setActiveItems();
    },
  },
  methods: {
    toggleMobileMenu() {
      const setting = "isMobileMenuOpen";
      const value = !this.settings[setting];
      this.$store.commit("CHANGE_SETTING", { setting, value });
    },
    toggleMenu() {
      const setting = "isMenuCollapsed";
      const value = !this.settings[setting];
      this.$store.commit("CHANGE_SETTING", { setting, value });
    },
    toggleSettings() {
      const setting = "isSidebarOpen";
      const value = !this.settings[setting];
      this.$store.commit("CHANGE_SETTING", { setting, value });
    },
    handleSubmenuClick(key) {
      const currentKey = this.activeSubmenu;
      if (this.flyoutActive) {
        return;
      }
      this.activeSubmenu = currentKey === key ? "" : key;
    },
    setActiveItems() {
      const menuData = this.menuData;
      const pathname = this.$route.path;

      const flattenItems = (items, key) =>
        items.reduce((flattenedItems, item) => {
          flattenedItems.push(item);
          if (Array.isArray(item[key])) {
            return flattenedItems.concat(flattenItems(item[key], key));
          }
          return flattenedItems;
        }, []);

      const activeItem = _.find(flattenItems(menuData, "children"), [
        "url",
        pathname,
      ]);

      // caso a rota nao esteja presente no sub-menu exemplo editar um merchant, onde o link vem dentro da listagem do merchant
      // e não precisa estar presente no menu ignora o código abaixo
      //console.log("activeItem1", activeItem);
      if (typeof activeItem === "undefined") return;

      const activeSubmenu = menuData.reduce((key, parent) => {
        try {
          if (Array.isArray(parent.children)) {
            parent.children.map((child) => {
              if (child.key === activeItem.key) {
                key = parent;
              }
              return "";
            });
          }
          return key;
        } catch (error) {
          return null;
        }
      });

      if (typeof activeItem.key !== "undefined") {
        this.activeItem = activeItem.key;
      }
      if (typeof activeSubmenu.key !== "undefined") {
        this.activeSubmenu = activeSubmenu.key;
      }
    },
    handleFlyoutOver(event, key, items) {
      if (this.flyoutActive) {
        clearInterval(this.flyoutTimers[key]);
        const item = event.currentTarget;
        const itemDimensions = item.getBoundingClientRect();
        this.renderedFlyoutItems = {
          ...this.renderedFlyoutItems,
          [key]: {
            key,
            itemDimensions,
            items,
          },
        };
      }
    },
    handleFlyoutOut(key) {
      if (this.flyoutActive) {
        this.flyoutTimers[key] = setTimeout(() => {
          const updatedFlyoutItems = Object.assign(
            {},
            this.renderedFlyoutItems
          );
          delete updatedFlyoutItems[key];
          this.renderedFlyoutItems = {
            ...updatedFlyoutItems,
          };
        }, 100);
      }
    },
    handleFlyoutContainerOver(key) {
      clearInterval(this.flyoutTimers[key]);
    },

    verificaPermissao(roles) {
      if (typeof roles === "undefined") {
        roles = [];
      }
      let permissao = false;
      // se o usuario eh sysadm ou se o menu nao possui roles definidas retorna true =)
      if (!this.papeisRaw.includes("SystemAdmin") && roles.length > 0) {
        roles.forEach((papel) => {
          permissao = permissao || this.papeisRaw.includes(papel);
        });
      } else {
        permissao = true;
      }
      return permissao;
    },

    verificarFeature(features) {

      if (typeof features === "undefined") {
        return true;
      }

      let feature = false;
            
      // se o usuario eh sysadm ou se o menu nao possui features definidas retorna true =)
      if (this.papeisRaw.includes("SystemAdmin")) return true;
        
        features.forEach((item) => {
          feature = feature || this.features.includes(item);
        });
        return feature;
      
     
    },

  },
};
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>

<style lang="scss" coped>
.front-version {
  text-align: center;
  color: #eeeeee;
  font-size: 10px;
}
</style>
